import { Injectable, signal } from '@angular/core';

/**
 * Updates a visually hidden live region so screen readers
 * announce dynamic content changes.
 */
@Injectable({ providedIn: 'root' })
export class ScreenReaderService {
  currentAnnouncement = signal('');

  announce(message: string) {
    this.currentAnnouncement.set(message);
  }
}
